const Blind = {
  borderRadius: "10px",
  hoverCardWidth: "500px",
  accentColor: "#f7931e",
  accentLighterColor: "#dd9745",
  accentTextColor: "#1a1a1a",
  criticalColor: "#e91619",
  criticalLighterColor: "#b72426",
  criticalTextColor: "#fff",
  primaryTextColor: "#000",
  secondaryTextColor: "#222",
  tertiaryTextColor: "#444",
  primaryColor: "#fff",
  secondaryColor: "#eee",
  tertiaryColor: "#ddd",
  quaternaryColor: "#ccc",
  quinaryColor: "#bbb",
  senaryColor: "#aaa",
  septenaryColor: "#999",
  bannerPrimaryColor: "#2a2a2a",
  bannerSecondaryColor: "#3a3a3a",
  bannerPrimaryTextColor: "#fff",
  bannerSecondaryTextColor: "#ddd",
  bannerTertiaryTextColor: "#ccc",
  bannerBottomBorderColor: "#3a3a3a",
  bannerOverlayShadow: "#1a1a1add",
  modalPrimaryColor: "#eee",
  modalSecondaryColor: "#ddd",
  modalTertiaryColor: "#ccc",
};

export default Blind;
